import { userAPI } from '@/services-ts/axios'
import type { ISelfRegistration, ISelfRegistrationUser } from '@/types/Data'
import type { IGetSelfRegistrationUserList, IPayloadSelfRegistration } from '@/types/Request'
import type { ISelfRegistrationStore } from '@/types/Store/State'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useSelfRegistrationStore = defineStore('selfRegistration', {
  state: (): ISelfRegistrationStore => ({
    selfRegistrations: [],
    users: {
      data: [],
      total: 0,
    },
  }),
  actions: {
    async GetSelfRegistrationList(): Promise<ISelfRegistration[]> {
      const { status, data } = await userAPI.SelfRegistrationServices.GetSelfRegistrationList()
      this.selfRegistrations = status && data ? data : []
      return this.selfRegistrations
    },

    async CreateSelfRegistration(payload: IPayloadSelfRegistration): Promise<boolean> {
      const { status, data } =
        await userAPI.SelfRegistrationServices.CreateSelfRegistration(payload)
      if (status) {
        this.selfRegistrations.unshift(data)
        void Alert({
          message: Format('admin_global_success'),
          type: 'success',
        })
      }
      return status
    },

    async UpdateSelfRegistration(payload: IPayloadSelfRegistration): Promise<boolean> {
      const { status, data } =
        await userAPI.SelfRegistrationServices.UpdateSelfRegistration(payload)
      if (status) {
        this.replace(data)
        void Alert({
          message: Format('admin_global_updated'),
          type: 'success',
        })
      }
      return status
    },

    async RegenerateSelfRegistrationToken(id: string): Promise<ISelfRegistration | null> {
      const { status, data } =
        await userAPI.SelfRegistrationServices.RegenerateSelfRegistrationToken(id)
      if (!status) return null
      this.replace(data)
      void Alert({
        message: Format('admin_global_updated'),
        type: 'success',
      })
      return data
    },

    async DeleteSelfRegistration(id: string): Promise<boolean> {
      const { status } = await userAPI.SelfRegistrationServices.DeleteSelfRegistration(id)
      if (status) {
        this.selfRegistrations = this.selfRegistrations.filter(item => item.id !== id)
        void Alert({
          message: Format('admin_global_deleted'),
          type: 'success',
        })
      }
      return status
    },

    async GetSelfRegistrationUserList(
      payload: IGetSelfRegistrationUserList,
    ): Promise<{ data: ISelfRegistrationUser[]; total: number }> {
      const { status, data, total } =
        await userAPI.SelfRegistrationServices.GetSelfRegistrationUserList(payload)
      this.users = status && data ? { data, total: total || 0 } : { data: [], total: 0 }
      return this.users
    },

    // Yeni dizi referansı UITable'daki seçimi sıfırlar; eski satır kopyası (iptal edilmiş token, eski form) kalmaz.
    replace(item: ISelfRegistration) {
      this.selfRegistrations = this.selfRegistrations.map(x => (x.id === item.id ? item : x))
    },
  },
})
